import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import AccountContext from '../../services/AccountContext';
import styles from './AdminLinks.module.less';

export default function AdminLinks({ children }) {
  const { isAdmin } = useContext(AccountContext);

  if (!isAdmin) {
    return null;
  }

  return (
    <div className={styles.info}>
      <strong>Admin Links:</strong>
      {children}
    </div>
  );
}

AdminLinks.propTypes = {
  children: PropTypes.node,
};
